import { notification } from 'antd';

export const showSuccessNotification = (message: string, description: string) =>
  notification['success']({ message, description, duration: 10 });
export const showErrorNotification = (message: string, description: string) =>
  notification['error']({ message, description, duration: 10 });
export const showInfoNotification = (message: string, description: string) =>
  notification['info']({ message, description, duration: 10 });
export const showWarnNotification = (message: string, description: string) =>
  notification['warn']({ message, description, duration: 10 });
